var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('p',{staticClass:"p1"},[_vm._v(_vm._s(_vm.$t('hometext-1')))]),_c('p',{staticClass:"p2",domProps:{"innerHTML":_vm._s(_vm.$t('hometext-2'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }